import { graphql } from 'gatsby';
import get from 'lodash.get';
import React from 'react';

import CallToAction from '../components/Common/CallToAction';
import ContentContainer from '../components/Common/ContentContainer';
import CustomerContentBlock from '../components/Common/CustomerContentBlock';
import PageSection from '../components/Common/PageSection';
import SquareCards from '../components/Common/SquareCards';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import * as styles from './customerSuccessShort.module.css';

const customerSuccessShort = ({ data: { page }, location }) => {
  return (
    <Layout>
      <MarketingSeo meta={page.pageMetaData} slug={location.pathname} />
      <PageSection isTopSection={true} className={styles.header}>
        <h4>{page.headingSuper}</h4>
        <h1>{page.heading}</h1>
      </PageSection>
      <ContentContainer wide>
        <CustomerContentBlock block={get(page, 'mainContent')} />
      </ContentContainer>
      {page.customerStories && page.customerStories.length > 0 && (
        <PageSection wide noPad={true}>
          <SquareCards cards={page.customerStories} />
        </PageSection>
      )}
      {page.bottomForm && (
        <PageSection className={styles.gray}>
          <CallToAction
            form={page.bottomForm}
            formId={get(page, 'bottomForm.marketoFormId')}
            copy={get(page, 'bottomForm.formCopy')}
          />
        </PageSection>
      )}
    </Layout>
  );
};

export default customerSuccessShort;

export const query = graphql`
  query CustomerSuccessShortTemplate($slug: String!) {
    page: contentfulCustomerSuccessShortTemplate(slug: { eq: $slug }) {
      ... on Node {
        ...CustomerSuccessShort
      }
    }
  }
`;
